module.exports = __webpack_public_path__ + "img/DE00701.10e114ae.png";